import styled from 'styled-components'

export const Wrap=styled.div`

.pdetail__footer{
    position:fixed;
    bottom:0;
    left:0;
}
`